/*eslint no-loop-func: 0 */
import React, { Component, Fragment } from 'react';
import { Col, Row, Container, Card, CardImg, CardImgOverlay } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import Css from './Experiences.scss';
import CssTile from './ThingsToDoTile/ThingsToDoTile.scss';
import ThingsToDoTile from './ThingsToDoTile/ThingsToDoTile';
import LockModal from './LockModal/LockModal';
//const Background = ImportImages('/experiences/background.jpg');
import Disclaimer from '@components/Experiences/Disclaimer/Disclaimer';
import Helmet from 'react-helmet';
import ExperiencesLandingData from '@components/ExperiencesLandingPage/LandingPageData';
import NavigationFooter from '@components/ExperiencesLandingPage/NavigationFooter/NavigationFooter';
import NextSteps from '@components/Experiences/NextSteps/NextSteps';
import ImportImages from '@src/importImages';

const Clouds = ImportImages('/experiences/clouds.jpg');
const LockIco = ImportImages('/experiences/lock-ico.png');
const UnlockIco = ImportImages('/experiences/unlock-ico.png');
const ExperienceBackground = ImportImages('/home/home-experiences.jpg');

class Experiences extends Component {
  state = {
    activeSlider: 0,
    backgroundHeight: '',
    locked: true,
    redirect: false,
    modalActive: false,
    passwordValidation: true,
    tiles: []
  };

  componentDidMount = () => {
    window.setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);

    let Tiles = [];
    /*jshint loopfunc:true */
    for (let key in ExperiencesLandingData) {
      ExperiencesLandingData[key].ThingsToDo.forEach((cur, ind) => {
        if (cur.visible === 1) {
          Tiles.push({ ...cur, city: key });
        }
      });
    }
    Tiles = this.shuffleArray(Tiles);

    let unlocked = localStorage.getItem('exclusiveUnlocked');
    if (unlocked !== null) {
      let unlockTime = parseInt(unlocked, 10);
      let currentTime = Math.floor(new Date().getTime() / 1000);

      if (unlockTime + 86400 < currentTime) {
        localStorage.removeItem('exclusiveUnlocked');
        unlocked = null;
      }
    }

    this.setState({
      tiles: Tiles,
      locked: unlocked === null
    });
  };

  toggleModal = () => {
    const current = this.state.modalActive;
    this.setState({
      modalActive: !current,
      redirect: false
    });
  };

  toggleTileModal = () => {
    const current = this.state.modalActive;
    this.setState({
      modalActive: !current,
      redirect: true
    });
  };

  unlock = password => {
    if (password === 'suitekey2020') {
      window.gtag('event', 'Successful Password Submission', {
        event_category: 'JS-Experiences-Engagement',
        event_label: 'Landing - Successful Unlock Action'
      });
      this.setState({
        locked: false,
        modalActive: false
      });
      localStorage.setItem(
        'exclusiveUnlocked',
        Math.floor(new Date().getTime() / 1000)
      );

      if (this.state.redirect) {
        this.props.history.push('/exclusive-experience');
      }
    } else {
      this.setState({
        passwordValidation: false
      });
    }
  };

  shuffleArray = array => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }

    return array;
  };

  render() {
    const isMobile = this.props.pageWidth < 992;

    let Tiles = [];
    this.state.tiles.forEach((cur, ind) => {
      if (Tiles.length < 31) {
        Tiles.push(
          <ThingsToDoTile
            {...cur}
            key={ind}
            locked={this.state.locked}
            toggleModal={this.toggleModal}
          />
        );
      }
    });
    return (
      <Fragment>
        <Helmet>
          <title>JetSuite Experiences | JetSuite</title>
          <meta
            name="description"
            content={
              'Whether it’s a simple weekend getaway, upgrading you to a premium suite, or providing you with access to the most sought-after events, all of this can be arranged through our partnership.'
            }
          />
        </Helmet>
        <Container
          fluid={true}
          style={
            !isMobile
              ? {
                  backgroundImage: `url(${ExperienceBackground})`,
                  backgroundSize: '100% auto',
                  overflow: 'hidden',
                  position: 'relative'
                }
              : {
                  backgroundImage: `url(${ExperienceBackground})`,
                  backgroundSize: 'auto 100%',
                  backgroundPosition: 'top center'
                }
          }
        >
          <div
            className={'position-absolute w-100 d-none d-md-block'}
            style={{ top: '0px', left: '0px' }}
          >
            <video
              id="background-video"
              loop
              autoPlay
              muted
              className={'w-100'}
            >
              <source
                src={
                  'https://d15vuanl9987q0.cloudfront.net/js-destinations-video-background-720p.mp4'
                }
                type="video/mp4"
              />
              <source
                src={
                  'https://d15vuanl9987q0.cloudfront.net/js-destinations-video-background-720p.mp4'
                }
                type="video/ogg"
              />
            </video>
          </div>

          <Row
            className={
              'text-center pt-5 pb-5 mx-auto ' + (isMobile ? 'w-100' : 'w-75')
            }
          >
            <Col
              id={'jetsuite-landingpage-textbox'}
              className="text-center p-4 mt-5 mb-3 lakes-medium"
              style={{
                backgroundColor: 'rgba(255,255,255, 0.7)'
              }}
            >
              <p className={'font-xl lakes-medium'}>JetSuite Experiences</p>
              <p
                className={
                  'mb-0 text-justify asap-regular ' +
                  (isMobile ? 'mx-2' : 'mx-5')
                }
              >
                Whether it’s a simple weekend getaway, upgrading you to a
                premium suite, or providing you with access to the most
                sought-after events, all of this can be arranged through our
                partnership.* We encourage you to think about the “why” you’re
                traveling. Is it a reward for hard work, to strengthen a bond
                with a loved one, or to feel a sense of adventure? Discover the
                featured activities and destinations below. If it's not listed
                here, we can take you there. Just ask!
              </p>
              <Link to={'/experiences-faq'} className={'btn btn-fullred mt-4'}>
                Embark: FAQ
              </Link>
            </Col>
          </Row>
        </Container>
        <Container className={'mt-5 mb-2'}>
          <Row>
            {this.state.locked ? (
              <div
                className={'mt-3 px-2 col-md-3 col-xs-12'}
                onClick={() => {
                  window.gtag('event', 'click', {
                    event_category: 'JS-Experiences-Engagement',
                    event_label: 'Landing - Exclusive Experiences'
                  });
                }}
              >
                <Card className={CssTile.Tile + ' border-0 text-center'}>
                  <CardImg
                    className="card-img-top"
                    src={Clouds}
                    alt="Card image cap"
                  />

                  <CardImgOverlay
                    className={
                      'p-2 text-center d-flex align-items-center pointer ' +
                      CssTile.Overlay
                    }
                    onClick={this.toggleTileModal}
                  >
                    <img
                      src={this.state.locked ? LockIco : UnlockIco}
                      alt={'Lock'}
                      className={'position-absolute'}
                      style={{ width: '40px', top: '-5px', left: '10px' }}
                    />
                    <div className={'align-middle w-100'}>
                      <p className={'mb-2 font-md'}>Exclusive Experiences</p>
                    </div>
                  </CardImgOverlay>
                </Card>
              </div>
            ) : (
              <Link
                to={'/exclusive-experience'}
                className={'mt-3 px-2 col-md-3 col-xs-12'}
                onClick={() => {
                  window.gtag('event', 'click', {
                    event_category: 'JS-Experiences-Engagement',
                    event_label: 'Landing - Exclusive Experiences'
                  });
                }}
              >
                <Card className={CssTile.Tile + ' border-0 text-center'}>
                  <CardImg
                    className="card-img-top"
                    src={Clouds}
                    alt="Card image cap"
                  />

                  <CardImgOverlay
                    className={
                      'p-2 text-center d-flex align-items-center pointer ' +
                      CssTile.Overlay
                    }
                  >
                    <img
                      src={UnlockIco}
                      alt={'Lock'}
                      className={'position-absolute'}
                      style={{ width: '40px', top: '-5px', left: '10px' }}
                    />
                    <div className={'align-middle w-100'}>
                      <p className={'mb-2 font-md'}>Exclusive Experiences</p>
                    </div>
                  </CardImgOverlay>
                </Card>
              </Link>
            )}

            {Tiles}
          </Row>
        </Container>

        <Container className={'mt-5 mb-4'}>
          <div
            className={
              'lakes-medium font-xl text-center pt-4 mb-3 ' + Css.header
            }
          >
            Featured Destinations & Hotels
          </div>
        </Container>

        <Container>
          <NavigationFooter location={'Landline'} hideNav={true} />
        </Container>

        {/* Next Steps */}
        <NextSteps
          pageWidth={this.props.pageWidth}
          location={'main'}
          eventName={'Landing - Join Button Clicks'}
        />

        <Disclaimer className={'pb-5 pt-3 px-3 font-xs text-justify'} />

        <LockModal
          {...this.state}
          toggleModal={this.toggleModal}
          unlock={password => this.unlock(password)}
        />
      </Fragment>
    );
  }
}

export default withRouter(Experiences);



// WEBPACK FOOTER //
// ./src/components/Experiences/Experiences.js